import React, { useState } from 'react';
import CaseList from './CaseList';
import CaseDetail from './CaseDetail';
import CaseCreator from './CaseCreator';
import './Cases.css';

const Cases = () => {
  const [selectedCase, setSelectedCase] = useState(null);
  const [isCreatingCase, setIsCreatingCase] = useState(false);

  return (
    <div className="cases-container">
      <div className="cases-header">
        <h2>Support Cases</h2>
        <button 
          className="create-case-btn"
          onClick={() => setIsCreatingCase(true)}
        >
          Create New Case
        </button>
      </div>

      <div className="cases-content">
        <CaseList onCaseSelect={setSelectedCase} />
        {selectedCase && (
          <CaseDetail 
            caseData={selectedCase}
            onClose={() => setSelectedCase(null)}
          />
        )}
      </div>

      {isCreatingCase && (
        <CaseCreator 
          onClose={() => setIsCreatingCase(false)}
          onCreated={(newCase) => {
            setIsCreatingCase(false);
            setSelectedCase(newCase);
          }}
        />
      )}
    </div>
  );
};

export default Cases; 